<template>
  <!-- content START here -->
  <div id="content">
    <!-- container START here -->
    <div class="container">
      <!-- main-colum START here -->
      <div id="main-colum">
        <h3>Edit User</h3>
        <form name="editUser" @submit.prevent="save()">
          <table>
            <tr>
              <td>
                Email:
              </td>
              <td>
                <input
                  v-model="user.email"
                  type="text"
                  name="email"
                  size="33"
                  maxlength="200"
                />
              </td>
            </tr>
            <tr>
              <td>Premium:</td>
              <td>
                <input
                  v-model="user.premium"
                  type="radio"
                  :value="1"
                  name="premiumYes"
                />
                <label for="premiumYes">Yes</label>
                <input
                  v-model="user.premium"
                  type="radio"
                  :value="0"
                  name="premiumNo"
                />
                <label for="premiumNo">No</label>
              </td>
            </tr>
            <tr>
              <td>Active:</td>
              <td>
                <input
                  v-model="user.active"
                  type="radio"
                  :value="1"
                  name="activeYes"
                />
                <label for="activeYes">Yes</label>
                <input
                  v-model="user.active"
                  type="radio"
                  :value="0"
                  name="activeNo"
                />
                <label for="activeNo">No</label>
              </td>
            </tr>
            <tr>
              <td>NFL:</td>
              <td>
                <input
                  v-model="user.nfl"
                  type="radio"
                  :value="1"
                  name="nflYes"
                />
                <label for="nflYes">Yes</label>
                <input
                  v-model="user.nfl"
                  type="radio"
                  :value="0"
                  name="nflNo"
                />
                <label for="nflNo">No</label>
              </td>
            </tr>
            <tr>
              <td>NCAAF:</td>
              <td>
                <input
                  v-model="user.ncaaf"
                  type="radio"
                  :value="1"
                  name="ncaafYes"
                />
                <label for="ncaafYes">Yes</label>
                <input
                  v-model="user.ncaaf"
                  type="radio"
                  :value="0"
                  name="ncaafNo"
                />
                <label for="ncaafNo">No</label>
              </td>
            </tr>
            <tr>
              <td>NBA:</td>
              <td>
                <input
                  v-model="user.nba"
                  type="radio"
                  :value="1"
                  name="nbaYes"
                />
                <label for="nbaYes">Yes</label>
                <input
                  v-model="user.nba"
                  type="radio"
                  :value="0"
                  name="nbaNo"
                />
                <label for="nbaNo">No</label>
              </td>
            </tr>
            <tr>
              <td>NCAAB:</td>
              <td>
                <input
                  v-model="user.ncaab"
                  type="radio"
                  :value="1"
                  name="ncaabYes"
                />
                <label for="ncaabYes">Yes</label>
                <input
                  v-model="user.ncaab"
                  type="radio"
                  :value="0"
                  name="ncaabNo"
                />
                <label for="ncaabNo">No</label>
              </td>
            </tr>
            <tr>
              <td>MLB:</td>
              <td>
                <input
                  v-model="user.mlb"
                  type="radio"
                  :value="1"
                  name="mlbYes"
                />
                <label for="mlbYes">Yes</label>
                <input
                  v-model="user.mlb"
                  type="radio"
                  :value="0"
                  name="mlbNo"
                />
                <label for="mlbNo">No</label>
              </td>
            </tr>
            <tr>
              <td>NHL:</td>
              <td>
                <input
                  v-model="user.nhl"
                  type="radio"
                  :value="1"
                  name="nhlYes"
                />
                <label for="nhlYes">Yes</label>
                <input
                  v-model="user.nhl"
                  type="radio"
                  :value="0"
                  name="nhlNo"
                />
                <label for="nhlNo">No</label>
              </td>
            </tr>
            <tr>
              <td>Change Password</td>
              <td>
                <input
                  v-model="password"
                  type="text"
                  name="password"
                  autocomplete="off"
                  maxlength="100"
                  :placeholder="`min ${MIN_PASSWORD_LENGTH} characters`"
                />
                <br />
                <small>Leave blank to keep the current password.</small>
              </td>
            </tr>
            <tr v-if="!membership">
              <td>
                <button class="big-btn orange" @click="addMembership()">
                  Add Membership
                </button>
              </td>
            </tr>
            <tr v-if="membership">
              <td>All Sports Expire</td>
              <td>
                <input
                  v-model="membership.allsports_expire"
                  type="date"
                  name="allSportsExpire"
                />
              </td>
            </tr>
            <tr v-if="membership">
              <td>NFL Expire</td>
              <td>
                <input
                  v-model="membership.nfl_expire"
                  type="date"
                  name="nflExpire"
                />
              </td>
            </tr>
            <tr v-if="membership">
              <td>NCAAF Expire</td>
              <td>
                <input
                  v-model="membership.ncaaf_expire"
                  type="date"
                  name="ncaafExpire"
                />
              </td>
            </tr>
            <tr v-if="membership">
              <td>NBA Expire</td>
              <td>
                <input
                  v-model="membership.nba_expire"
                  type="date"
                  name="nbaExpire"
                />
              </td>
            </tr>
            <tr v-if="membership">
              <td>NCAAB Expire</td>
              <td>
                <input
                  v-model="membership.ncaab_expire"
                  type="date"
                  name="ncaabExpire"
                />
              </td>
            </tr>
            <tr v-if="membership">
              <td>MLB Expire</td>
              <td>
                <input
                  v-model="membership.mlb_expire"
                  type="date"
                  name="mlbExpire"
                />
              </td>
            </tr>
            <tr v-if="membership">
              <td>NHL Expire</td>
              <td>
                <input
                  v-model="membership.nhl_expire"
                  type="date"
                  name="nhlExpire"
                />
              </td>
            </tr>
          </table>
          <p>
            <input type="submit" name="submit" value="Save" />
          </p>
        </form>
        <!-- main-colum END here -->
      </div>
      <!-- container END here -->
    </div>
    <!-- content END here -->
  </div>
</template>

<script>
import UserRepository from "../../data/user.repository.js";
import MembershipRepository from "../../data/membership.repository.js";
import { MIN_PASSWORD_LENGTH } from "../../constants";
import _ from "lodash";
export default {
  data() {
    return {
      user: {},
      membership: undefined,
      password: "",
      originalPremium: "",
      MIN_PASSWORD_LENGTH,
    };
  },
  mounted() {
    if (!this.user.id) return;
    MembershipRepository.get(this.user.id).then((result) => {
      this.membership = _.isEmpty(result) ? undefined : result;
    });
  },
  created() {
    const storeUser = this.$store.getters.editUser();
    // editUser lives only in the store, so a hard refresh here leaves us with
    // no user to save. Send the admin back to search rather than posting a
    // payload with no id.
    if (!storeUser || !storeUser.id) return this.$router.replace("/admin/users");
    // Copy so the form doesn't mutate the stored user in place.
    this.user = { ...storeUser };
    this.originalPremium = String(storeUser.premium);
  },
  methods: {
    save() {
      if (this.password && this.password.length < MIN_PASSWORD_LENGTH)
        return this.$root.$refs.toastr.e(
          `Password must be at least ${MIN_PASSWORD_LENGTH} characters`,
        );
      // Only block on the missing-membership rule when premium is actually
      // being granted. Otherwise a password reset for an existing premium user
      // with no membership row can never be saved.
      if (this.user.premium && !this.membership && this.premiumChanged())
        return this.$root.$refs.toastr.e("Premium user must have membership");

      const changingPassword = !!this.password;
      const payload = changingPassword
        ? { ...this.user, password: this.password }
        : { ...this.user };

      UserRepository.save(payload)
        .then(() => {
          const memPromise =
            this.membership && this.user.premium
              ? MembershipRepository.save(this.membership)
              : Promise.resolve(true);
          return memPromise.then(() => {
            this.password = "";
            if (changingPassword) {
              // Stay put so the admin can read the confirmation and copy the
              // password they just set.
              this.$root.$refs.toastr.s(
                `Password updated for ${this.user.email}`,
              );
            } else {
              this.$root.$refs.toastr.s("User saved");
              this.$router.push("/admin");
            }
          });
        })
        .catch(() => this.$root.$refs.toastr.e("An error occurred"));
    },
    premiumChanged() {
      return this.originalPremium !== String(this.user.premium);
    },
    addMembership() {
      this.membership = {
        allsports_expire: new Date().toISOString().substring(0, 10),
        user_id: this.user.id,
      };
    },
  },
};
</script>

<style lang="css" scoped></style>



// WEBPACK FOOTER //
// EditUser.vue?247b8d6e